export default "__VITE_ASSET__pujFlDfW__"